import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useLanguage } from '../../hooks/useLanguage';

function PopupLoginError({ isPopup, setIsPopup, onConfirm }) {
    const { t } = useLanguage();
    const [popupActive, setPopupActive] = useState(false);

    useEffect(() => {
        document.body.style.overflow = isPopup ? 'hidden' : 'auto';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isPopup]);

    useEffect(() => {
        if (isPopup) {
            const timeout = setTimeout(() => setPopupActive(true), 100);
            return () => clearTimeout(timeout);
        }
        setPopupActive(false);
    }, [isPopup]);

    const handleClose = (e) => {
        e.preventDefault();

        const action = typeof isPopup === 'object' ? isPopup.action : null;

        if (action === 'maintain_ui') {
            if (onConfirm) {
                onConfirm();
            }
            setIsPopup(false);
            return;
        }

        if (action === 'navigate_main' && typeof window.navigateToMain === 'function') {
            window.navigateToMain();
            delete window.navigateToMain;
        }

        setIsPopup(false);
        if (onConfirm) onConfirm();
    };

    const handleBackgroundClick = (e) => {
        const action = typeof isPopup === 'object' ? isPopup.action : null;
        
        if (action === 'maintain_ui') {
            if (onConfirm) {
                onConfirm();
            }
            setIsPopup(false);
            return;
        }
        
        if (e.target.className === 'popup-box-component') {
            setIsPopup(false);
        }
    };

    if (!isPopup) return null;

    const popupMessage = typeof isPopup === 'object' ? isPopup.message : isPopup;

    // Portal로 렌더링
    return ReactDOM.createPortal(
        <div className="popup-box-component" onClick={handleBackgroundClick}>
            <div className={`box alert ${popupActive ? 'active' : ''}`}>
                <div className="popup-content">
                    <p className="p3_1" dangerouslySetInnerHTML={{ __html: popupMessage }} />
                    <button type="button" className="confirm-btn min_122" onClick={handleClose}>
                        {t('confirm')}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default PopupLoginError;
